import React from 'react';
import PropTypes from 'prop-types';

import FilterNumberPair from 'components/search_sidebar/filter_number_pair';
import { Col, Row } from 'react-bootstrap-5';

export default class MultifamilyFilters extends React.Component {
  static propTypes = {
    filterKeyMappings: PropTypes.object.isRequired,
    filterLabelMappings: PropTypes.object.isRequired,
    multifamilyFilter: PropTypes.object.isRequired,
    onMultifamilyFilterChange: PropTypes.func.isRequired,
  };

  handleChange = (e, name) => {
    this.props.onMultifamilyFilterChange(e, name);
  };

  render() {
    const { filterKeyMappings, filterLabelMappings, multifamilyFilter } =
      this.props;

    return (
      <div className="d-flex flex-column gap-3">
        <div className="multifamily-information d-flex flex-column gap-2">
          <Row>
            <Col>
              <FilterNumberPair
                filter={multifamilyFilter}
                label={filterLabelMappings['beds']}
                name="beds"
                valueKeys={filterKeyMappings['beds']}
                onChange={this.handleChange}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <FilterNumberPair
                filter={multifamilyFilter}
                label={filterLabelMappings['baths']}
                name="baths"
                valueKeys={filterKeyMappings['baths']}
                onChange={this.handleChange}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <FilterNumberPair
                filter={multifamilyFilter}
                label={filterLabelMappings['size']}
                name="size"
                valueKeys={filterKeyMappings['size']}
                onChange={this.handleChange}
              />
            </Col>
          </Row>
        </div>
        <div className="multifamily-information">
          <Row>
            <Col>
              <FilterNumberPair
                filter={multifamilyFilter}
                label={filterLabelMappings['rent']}
                name="rent"
                valueKeys={filterKeyMappings['rent']}
                onChange={this.handleChange}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <FilterNumberPair
                filter={multifamilyFilter}
                label={filterLabelMappings['marketRent']}
                name="marketRent"
                valueKeys={filterKeyMappings['marketRent']}
                onChange={this.handleChange}
              />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
